import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 600 600",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M142.8,596.27h314.49c63.54,0,115.24-51.71,115.24-115.24l-.03-314.55c0-63.54-51.71-115.24-115.24-115.24h-17.12v-31.94c0-8.58-7-15.57-15.57-15.57s-15.57,7-15.57,15.57v31.94h-218.01v-31.94c0-8.58-7-15.57-15.57-15.57s-15.57,7-15.57,15.57v31.94h-17.12c-63.54,0-115.24,51.71-115.24,115.24v314.49c0,63.54,51.71,115.24,115.24,115.24l.09.05ZM142.8,82.38h17.12v23.36c0,8.58,7,15.57,15.57,15.57s15.57-7,15.57-15.57v-23.36h218.01v23.36c0,8.58,7,15.57,15.57,15.57s15.57-7,15.57-15.57v-23.36h17.12c46.41,0,84.1,37.78,84.1,84.1v24.91H58.7v-24.91c0-46.41,37.78-84.1,84.1-84.1h0ZM58.7,222.53h482.75v258.5c0,46.41-37.78,84.1-84.1,84.1H142.8c-46.41,0-84.1-37.78-84.1-84.1V222.53Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M264.73,457.91c3.04,3.04,7,4.59,10.98,4.59s7.94-1.55,10.98-4.59l112.36-112.36c6.08-6.08,6.08-15.97,0-22.02-6.08-6.08-15.97-6.08-22.02,0l-101.38,101.38-52.8-52.8c-6.08-6.08-15.97-6.08-22.02,0-6.08,6.08-6.08,15.97,0,22.02l63.78,63.78h.12Z"
	})]
});
export default SvgBook;
